export const LOCAL_STORAGE_KEYS = {
  DISMISSED_UPDATES: 'dismissedUpdates',
  DISMISSED_PLATFORM_BANNERS: 'dismissedPlatformBanners',
  WIDGET_BUILDER: 'widgetBubble_',
  DRAFT_MESSAGES: 'draftMessages',
  COLOR_SCHEME: 'color_scheme',
  PRIMARY_COLOR: 'primary_color',
  DARK_COLOR_SCHEME: 'dark_color_scheme',
  DASHBOARD_FONT: 'dashboard_font',
  NOTIFICATION_GROUP_STYLE: 'notification_group_style',
  NOTIFICATION_POSITION: 'notification_position',
  DISMISSED_LABEL_SUGGESTIONS: 'labelSuggestionsDismissed',
  MESSAGE_REPLY_TO: 'messageReplyTo',
  RECENT_SEARCHES: 'recentSearches',
  CONVERSATION_WALLPAPER: 'conversation_wallpaper',
  PINNED_CONVERSATIONS: 'pinnedConversations',
  FAVORITE_LABELS: 'favoriteLabels',
  FAVORITE_INBOXES: 'favoriteInboxes',
  SIDEBAR_MINIMIZED_SECTIONS: 'sidebarMinimizedSections',
};
